import React, { useState, useEffect } from 'react';
import { useBeneficiaries } from 'contexts/Beneficiaries';
import usePagination from '../../hooks/usePagination';

const PaginationComponent = ({ totalPages }) => {
  const { currentPage, inputValue, goToPage, nextPage, prevPage, handleInputChange } = usePagination(totalPages);
  const { selectedPage } = useBeneficiaries();

  const [isInputInvalid, setIsInputInvalid] = useState(false);

  useEffect(() => {
    if (inputValue && (inputValue < 1 || inputValue > totalPages)) {
      setIsInputInvalid(true);
    } else {
      setIsInputInvalid(false);
    }
  }, [inputValue, totalPages]);

  useEffect(() => {
    selectedPage(currentPage);
  }, [currentPage]);

  const renderPageNumbers = () => {
    const pages = [];
    const lastPageToShow = Math.min(currentPage + 3, totalPages);

    for (let i = currentPage; i <= lastPageToShow; i++) {
      pages.push(
        <button
          type="button"
          key={i}
          onClick={() => {
            goToPage(i);
            selectedPage(currentPage);
          }}
          className={currentPage === i ? 'active' : ''}
        >
          {i}
        </button>,
      );
    }

    if (totalPages > lastPageToShow) {
      pages.push(<span key="dots">...</span>);
      pages.push(
        <button
          type="button"
          key={totalPages}
          onClick={() => {
            goToPage(totalPages);
            selectedPage(currentPage);
          }}
          className={currentPage === totalPages ? 'active' : ''}
        >
          {totalPages}
        </button>,
      );
    }

    return pages;
  };

  if (totalPages <= 1) {
    return null;
  }

  return (
    <div className="pagination-container">
      <button
        type="button"
        data-testid="button-go-to-page"
        onClick={() => {
          prevPage();
        }}
        disabled={currentPage === 1}
        className={currentPage === 1 ? 'disabled' : ''}
      >
        &lt;
      </button>

      {renderPageNumbers()}

      <button
        type="button"
        onClick={() => {
          nextPage();
        }}
        disabled={currentPage === totalPages}
        className={currentPage === totalPages ? 'disabled' : ''}
      >
        &gt;
      </button>

      <span>
        Mostrando de {currentPage * 25 - 24} a {Math.min(currentPage * 25, totalPages * 25)}
      </span>

      {totalPages > 1 && (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            goToPage(inputValue);
          }}
          className="go-to-page"
        >
          <label>
            Ir para a página:{' '}
            <input value={inputValue} onChange={handleInputChange} className={isInputInvalid ? 'invalid' : ''} />
          </label>
          <button type="submit">Ir</button>
        </form>
      )}
    </div>
  );
};

export default PaginationComponent;
